import {Inject, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouterService {

  constructor(@Inject('$state') private $state, @Inject('$window') private $window) {
  }

  routeTo(path: string, params?: {}) {
    this.$state.go(path, params)
  }

  routeToNewTab(path: string, params?: {}) {
    const url = this.$state.href(path, params);
    this.$window.open(url, '_blank');
  }

}
